import React from "react";
import { Check, X } from "lucide-react";
import { type PasswordStrength } from "@/utils/passwordValidation";

interface Props {
  strength: PasswordStrength;
}

export function PasswordStrengthIndicator({ strength }: Props) {
  const colors = ["bg-red-500", "bg-orange-500", "bg-yellow-500", "bg-green-500"];
  const labels = ["Weak", "Fair", "Good", "Strong"];

  return (
    <div className="space-y-2 mt-2">
      <div className="flex gap-1">
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            className={`h-1.5 flex-1 rounded-full transition-colors ${
              i <= strength.score ? colors[strength.score] : "bg-muted"
            }`}
          />
        ))}
      </div>
      <div className="flex justify-between items-center">
        <span className={`text-xs font-medium ${colors[strength.score].replace("bg-", "text-")}`}>
          {labels[strength.score]}
        </span>
      </div>
      <ul className="space-y-1">
        {strength.checks.map((check) => (
          <li key={check.label} className="flex items-center gap-2 text-xs">
            {check.passed ? (
              <Check className="h-3 w-3 text-green-500" />
            ) : (
              <X className="h-3 w-3 text-muted-foreground" />
            )}
            <span className={check.passed ? "text-foreground" : "text-muted-foreground"}>
              {check.label}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
